import Schedule from './Schedule';
import ScheduleTick from './ScheduleTick';

const strftime = require('strftime');
const beginDay = (ymd, week) => {
	let year = ymd.substr(0, 4)
	let month = ymd.substr(4, 2);
	let day = ymd.substr(6, 2);

	return new Date(year, month - 1, day - week);
}

export default class Week {
	get schedule() {
		return new Schedule({
			begin: this.begin.clone,
			end  : this.end.clone,
		});
	}

	get firstDay() {
		return parseInt(this.begin.code.substr(6, 2));
	}

	constructor(params) {
		this.code = params.code;
		this.begin = params.begin;
		this.end = params.end;
		this.number = params.number;
	}

	static fromDate(date) {
		return Week.fromYMD(strftime('%Y%m%d', date), date.getDay());
	}

	static fromYMD(ymd, youbi) {
		let begin = beginDay(ymd, youbi);
		let end = new Date(begin)
		end.setDate(begin.getDate() + 6);
		let first_day_of_year = new Date(begin);
		first_day_of_year.setMonth(0);
		first_day_of_year.setDate(1);
		let week = Math.floor((begin - first_day_of_year) / (7 * 24 * 60 * 60 * 1000));
		let code = strftime('%Y%m', begin) + ('0' + week).substr(-2);

		return new Week({
			'code': code,
			'begin': new ScheduleTick({code :strftime('%Y%m%d', begin) + ScheduleTick.TERM.AM}),
			'end': new ScheduleTick({code: strftime('%Y%m%d', end) + ScheduleTick.TERM.PM}),
			'number': week,
		});
	}
}
